angular.module('routes.cases.states.StatesController', [
  'stack'
])

/**
 * The StatesController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class StatesController
 * @constructor
 * @module routes.cases.states.StatesController
 */
.controller('StatesController', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  'constants',
  'ModelsService',
  'CasesService',
  'StatesService',
  'RulesService',
  'DecisionsService',
  'WidgetsService',
  'TemplatesService',
  'DuplicateService',
  function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    constants,
    ModelsService,
    CasesService,
    StatesService,
    RulesService,
    DecisionsService,
    WidgetsService,
    TemplatesService,
    DuplicateService
  ) {
    'use strict';

    $scope.constants = null;

    $scope.form = {
      template: null,
      schema: null,
      form: null,
      model: {
        label: '',
        type: '',
        relatives: []
      }
    };

    $scope.settings = {};

    $scope.state = $state;

    $scope.states = {
      list: [],
      current: null,
      formatted: null
    };

    $scope.disableSave = true;

    $scope.sortableOptionsStates = {
      containment: 'parent',
      tolerance: 'pointer',
      stop: function () {
        var relatives = _.cloneDeep($scope.cases.current.relatives);
        relatives = _.reject(relatives, { model: 'states' });

        relatives = relatives.concat($scope.states.list);
        CasesService
          .updateRelatives($scope.cases.current, relatives)
          .then(function () {
            console.log('States List Updated');
            return;
          })
          .catch(function () {
            console.log('ERROR Saving states list');
          });
      }
    };

    $scope.sortableOptionsWidgets = {
      containment: 'parent',
      tolerance: 'pointer',
      stop: function () {
        var relatives = _.cloneDeep($scope.cases.current.relatives);
        relatives = _.reject(relatives, { model: 'widgets' });

        relatives = relatives.concat($scope.widgets.all);
        CasesService
          .updateRelatives($scope.cases.current, relatives)
          .then(function () {
            console.log('Widgets List Updated');
            return;
          })
          .catch(function () {
            console.log('ERROR Saving widgets list');
          });
      }
    };


    /**
     * Saves a model pulled from the current content
     */
    $scope.saveModel = function saveModel() {
      // var model = StatesService
      //   .populateModel($scope.states.current, $scope.currentContent.getModel());
      StatesService
        .update($scope.states.current, $scope.currentContent.getModel(), $scope.cases.current)
        .then(function (response) {
          if (CasesService.queue[0]) {
            StatesService.queue = _.reject(StatesService.queue, { id: response.id });

            if (StatesService.queue[0]) {
              $state.go(
                'routes.cases.states',
                {
                  stateId: StatesService.queue[0].id,
                  stateMode: 'edit'
                }
              );
            } else {
              CasesService.queue = _.reject(CasesService.queue, { id: $state.params.caseId });
              console.log('Cases left: ' + CasesService.queue.length);
              if (CasesService.queue[0]) {
                $state.go(
                  'routes.cases.states',
                  {
                    caseId: CasesService.queue[0].id,
                    stateId: CasesService.queue[0].content.start,
                    stateMode: 'edit'
                  }
                );
              } else {
                $rootScope.loadingDisabled = false;
                console.log('Magic Save Complete!');
                $state.go('routes.magic');
              }
            }
          } else {
            $state.go('routes.cases.states', { stateId: $state.params.stateId, stateMode: null });
          }
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Creates a new state model
     */
    $scope.newState = function newState() {
      var temporaryStateid;

      DecisionsService
        .create()
        .then(function (decisionResponse) {
          $scope.form.model.relatives = StatesService
            .addRelative($scope.form.model.relatives, decisionResponse);
          return RulesService.create();
        })
        .then(function (ruleResponse) {
          $scope.form.model.relatives = StatesService
            .addRelative($scope.form.model.relatives, ruleResponse);
          return StatesService.create(newStateFactory($scope.form.model), $scope.cases.current);
        })
        .then(function (stateResponse) {
          temporaryStateid = stateResponse.id;
          return CasesService.addRelative($scope.cases.current, stateResponse);
        })
        .then(function () {
          $state.go(
            'routes.cases.states',
            { stateId: temporaryStateid, stateMode: null },
            { reload: true }
          );
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Duplicates a state
     *
     * @param {string} id - State identifier
     */
    $scope.duplicateState = function duplicateState(id) {
      var state = StatesService.get(id);

      DuplicateService
        .duplicateState($scope.cases.current, state)
        .then(function (response) {
          var c = _.find(response, { model: 'cases' });
          state = _.find(response, { model: 'states' });

          console.log(response);
          console.log(c.relatives);
          console.log($scope.cases.current.relatives);
          $scope.cases.current.relatives = c.relatives;

          $state.go(
            'routes.cases.states',
            { stateId: state.id, stateMode: null },
            { reload: true }
          );
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Duplicates a widget
     *
     * @param {string} id - Widget identifier
     */
    $scope.duplicateWidget = function duplicateWidget(id) {
      var widget = WidgetsService.get(id);

      DuplicateService
        .duplicateWidget($scope.cases.current, widget)
        .then(function (response) {
          var c = _.find(response, { model: 'cases' });
          widget = _.find(response, { model: 'widgets' });

          console.log(response);
          console.log(c.relatives);
          console.log($scope.cases.current.relatives);
          $scope.cases.current.relatives = c.relatives;

          $state.go(
            'routes.cases.states.widgets',
            { widgetId: widget.id, widgetMode: null },
            { reload: true }
          );
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * UI trigger for deleting a State
     *
     * @param {string} stateId - State identifier
     */
    $scope.deleteState = function deleteState(stateId) {
      CasesService.removeRelative($scope.cases.current, stateId)
      .then(function () {
        $state.go(
          'routes.cases.states',
          { caseId: $state.params.caseId, stateId: null, stateMode: null },
          { reload: true, inherit: false, notify: true }
        );
        return;
      })
      .catch(function (err) {
        console.log(err);
      });
    };

    /**
     * UI trigger for selecting a template
     */
    $scope.selectTemplate = function selectTemplate() {
      var schema = ModelsService.find('schemas', 'label', $scope.form.template.key);

      $scope.form.schema = schema.content.schema;
      $scope.form.form = schema.content.form;
      $scope.form.model = {};

      $scope.states.current = newStateFactory($scope.form.model.title, $scope.form.template.key);
    };

    $scope.setStateAsStart = function () {
      var data;

      data = {
        content: $scope.cases.current.content
      };

      data.content.start = $state.params.stateId;
      CasesService
        .update($state.params.caseId, data)
        .then(function () {
          $state.reload();
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    $scope.saveGlobalSettings = function () {
      var data = {
        content: $scope.cases.current.content
      };

      data.content.settings = $scope.settings;

      CasesService
        .update($state.params.caseId, data)
        .then(function () {
          $state.go(
            'routes.cases.states',
            { stateId: $scope.cases.current.content.start, stateMode: 'edit' }
          );
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Returns a new state object
     * TODO: Move this to a service.
     *
     * @param {Object} model - model to generate
     * @return {Object} formatted model
     */
    function newStateFactory(model) {
      var decision = _.find(model.relatives, { model: 'decisions' });
      var rule = _.find(model.relatives, { model: 'rules' });
      var state = {
        label: model.label,
        content: {
          type: model.type,
          decisions: [decision.id],
          rules: [rule.id],
          widgets: []
        },
        relatives: model.relatives
      };

      return state;
    }

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants.constants;

      TemplatesService.setTemplates($scope.constants);
    }

    /**
     * Method sets state data from Model
     *
     * @private
     */
    function defineStateList() {
      var stateList = [];

      console.log('defineStateList');

      if ($scope.cases.current) {
        stateList = _.filter($scope.cases.current.relatives, function (obj) {
          return _.includes(obj.classes, 'states');
        });

        if (StatesService.queue.length === 0) {
          StatesService.queue = _.cloneDeep(stateList);
        }
      }

      $scope.states.list = stateList;
      StatesService.setStatesListTitleMap(stateList);
    }

    /**
     * Method sets widget data from Model
     *
     * @private
     */
    function defineWidgetList() {
      if ($scope.states.current) {
        $scope.widgets.all = WidgetsService
          .getWidgetsFromRelatives($scope.cases.current.relatives);
        $scope.widgets.list = WidgetsService
          .getWidgetsFromRelatives($scope.states.current.relatives);
      }

      _.forEach($scope.widgets.all, function (all) {
        var found;

        found = _.find($scope.widgets.list, { id: all.id });

        if (found) {
          $scope.widgets.active[all.id] = true;
        } else {
          $scope.widgets.active[all.id] = false;
        }
      });

      if ($state.params.widgetId) {
        $scope.widgets.current = ModelsService.find('widgets', 'id', $state.params.widgetId);
      }
    }

    /**
     * Defines the current state
     */
    function defineCurrentState() {
      if ($state.params.stateId) {
        $scope.states.current = StatesService.get($state.params.stateId);
        $scope.states.formatted = StatesService.get($state.params.stateId, true);
        $scope.states.formatted.content.decisions = DecisionsService
          .get($scope.states.current.content.decisions[0], true);
        $scope.states.formatted.content.rules = RulesService
          .get($scope.states.current.content.rules[0], true);

        // var schema = ModelsService.find('schemas', 'label', $scope.states.current.content.type);
        // $scope.form.schema = schema.content.schema;
        // $scope.form.form = schema.content.form;
        // TemplatesService.setTemplates($scope.constants);
        // $scope.form.model = StatesService
        //   .populateModel(
        //     TemplatesService.getModel($scope.states.current.content.type),
        //     $scope.states.current
        //   );

        console.log('Current State: ', $scope.states.current.id, $scope.states.current.label);
      } else {
        $scope.states.current = null;
      }

      if (CasesService.queue[0] && $state.params.stateMode === 'edit') {
        $timeout($scope.saveModel, 250);
      }
    }

    function defineSettings() {
      $scope.settings = _.cloneDeep($scope.cases.current.content.settings) || {};

      $scope.$on('can-save', function (event, data) {
        $scope.disableSave = data.canSave;
      });

      $scope.$on('state-form-valid', function (event, validity) {
        $scope.formInvalid = !validity;
      });
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineConstants();
      defineStateList();
      defineCurrentState();
      defineSettings();
      defineWidgetList();
    }
    initialize();
  }
]);
